import { render, staticRenderFns } from "./TSZ_Registro_Externo.vue?vue&type=template&id=d0abc512&scoped=true&"
import script from "./TSZ_Registro_Externo.vue?vue&type=script&lang=js&"
export * from "./TSZ_Registro_Externo.vue?vue&type=script&lang=js&"
import style0 from "./TSZ_Registro_Externo.vue?vue&type=style&index=0&id=d0abc512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0abc512",
  null
  
)

export default component.exports